import { useAppContext } from "@/App";
import { BackendPromise, getEventSubmitter, is_str } from "@components/Utils";

/**
 * Хук useRequest для запросов в апи.
 * Проставляет глобальный стейт setApiIsLoading, на основе данных сабмиттера.
 * Это повзоляет автоматически отслеживать состояние спиннера в SpinnerButton.
 * Для этого нужно передать опциональный параметр ev.
 */
export const useRequest = () => {
    const { setApiIsLoading } = useAppContext();

    const _getEventSubmitter = (ev) => {
        // ev можно передать null т.к не всегда есть событие
        if ([null, undefined].includes(ev)) return;

        // ev можно передать строку для кастомных событий
        if (is_str(ev)) return ev;

        const { tn, tv } = getEventSubmitter(ev);
        return tn === undefined ? true : tn + (tv ? "-" + tv : "");
    };

    const api_get = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.get(url, opts.params)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const api_post = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.post(url, opts.params)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const api_post_formdata = (ev, url, formdata, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.post_real_formdata(url, formdata)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const api_delete = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.delete(url)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const ext_api_get = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.ext_api_get(url, opts.params)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const ext_api_post = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.ext_api_post(url, opts.params)
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    const ext_api_delete = (ev, url, opts = {}) => {
        const nameLoading = _getEventSubmitter(ev);
        if (nameLoading) {
            setApiIsLoading(nameLoading);
        }
        BackendPromise.ext_api_delete(url, opts.fetch_params || {})
            .then((resp) => {
                if (opts.then) opts.then(resp);
            })
            .finally(() => {
                if (opts.finally === false) {
                    return;
                }
                setApiIsLoading(false);
                if (opts.finally) opts.finally();
            });
    };

    return { api_get, api_post, api_post_formdata, api_delete, ext_api_get, ext_api_post, ext_api_delete };
};
